import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_component_Button, {
    plain: "",
    small: $props.small
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Icon, {
        icon: $props.icon,
        width: $props.width,
        height: $props.height
      }, null, 8 /* PROPS */, ["icon", "width", "height"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["small"]))
}